import { useEffect, useState } from 'react'

export interface CountdownParts {
  hours: string
  minutes: string
  seconds: string
}

const pad = (n: number): string => n.toString().padStart(2, '0')

/**
 * Counts down from `durationSeconds` and restarts automatically at zero.
 */
export function useCountdown(durationSeconds: number): CountdownParts {
  const [remaining, setRemaining] = useState(durationSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? durationSeconds : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [durationSeconds])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
